import type { SelectionToolbarState } from "../tracker/PaintController";
import { SelectionToolsButtons } from "./SelectionToolsButtons";

export type SelectionToolbarProps = {
  state: SelectionToolbarState;
  onRamp: () => void;
  onFillTop: () => void;
  onRandomHex: () => void;
};

/**
 * Floating tools for multi-row selections (fill-from-top / hex ramp / random hex).
 * Anchored to the right of the tracker cursor so it doesn't cover glyphs.
 */
export function SelectionToolbar({
  state,
  onRamp,
  onFillTop,
  onRandomHex,
}: SelectionToolbarProps) {
  const { anchor, canRamp, canFillTop } = state;
  const midY = (anchor.top + anchor.bottom) / 2;

  return (
    <div
      className="pointer-events-auto fixed z-[120] rounded-md border border-lab-line bg-lab-panel p-1 shadow-[0_8px_20px_rgba(0,0,0,0.4)]"
      style={{
        left: anchor.right + 8,
        top: midY,
        transform: "translateY(-50%)",
      }}
    >
      <SelectionToolsButtons
        orientation="horizontal"
        canFillTop={canFillTop}
        canRamp={canRamp}
        canRandomHex={true}
        onFillTop={onFillTop}
        onRamp={onRamp}
        onRandomHex={onRandomHex}
      />
    </div>
  );
}
